import { MetricsDetails, PzResponse } from './model/pz-response';
import { BffResponseObject, ErrorResponse } from './model/response';
import { PzAnalytics } from 'models';
import HttpMethod from 'sources/http-methods';

export class PartnerPerfSource {
  public async getPzAnalytics(metricRequest: PzAnalytics): Promise<BffResponseObject<MetricsDetails[]>> {
    const response = await fetch('/api/v1/pz/analytics', {
      method: HttpMethod.POST,
      body: JSON.stringify(metricRequest),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      } as HeadersInit,
    });

    const data: PzResponse = await response.json();

    if (data.success === true) {
      const overallMetrics = data.body.clicks.map((clickMetric) => {
        const targetedConversionMetric = data.body.conversions.find(
          (conversion) => conversion.campaign_id === clickMetric.campaign_id,
        );

        return {
          ...clickMetric,
          ...targetedConversionMetric,
        };
      });

      return {
        success: true,
        error: null,
        resBody: overallMetrics,
      };
    } else {
      return Promise.reject({
        message: data.errorCode,
        detail: {
          statusCode: data.body.code,
          statusMessage: data.body.message,
        },
      } as ErrorResponse<{ statusCode: string; statusMessage: string }>);
    }
  }
}
